import { PostUsersMeOrganisationsCurrentCoverageApiArg } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";
import { resourceDetailsTargetResourceSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceSelector";
import { resourceDetailsCoverageDatesSelector } from "@/store/resource-details/selectors/coverage-data/options/resourceDetailsCoverageDatesSelector";
import { resourceDetailsCoverageDataPointSelector } from "@/store/resource-details/selectors/coverage-data/options/resourceDetailsCoverageDataPointSelector";

export const resourceDetailsResourceCoverageDataPayloadSelector = (
  state: RootState,
): PostUsersMeOrganisationsCurrentCoverageApiArg | undefined => {
  const resource = resourceDetailsTargetResourceSelector(state);
  const dates = resourceDetailsCoverageDatesSelector(state);
  const dataGranularity = resourceDetailsCoverageDataPointSelector(state);

  if (!resource) {
    return;
  }

  return {
    body: {
      account_id: resource.accountId,
      cloud_provider: resource.provider,
      dates: dates,
      data_granularity: dataGranularity,
      filter_tree: {
        operator: "in",
        node_type: "item",
        value: resource.billing_explorer_resource_identifier,
        type: "resource_id",
        filter_provider: resource.provider,
      },
    },
  };
};
